import { c as _c } from "react/compiler-runtime";
import { chakra, Link } from '@chakra-ui/react';
import { StartupscomLogoSvg } from '@src/components/sco/StartupscomLogoSvg';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import * as React from 'react';
export const StartupscomLogo = props => {
  const $ = _c(9);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = props.size == "sm" || getBreakpointValue({
    base: true,
    lg: false
  });
  const t0 = props.href || "/";
  let t1;
  if ($[0] !== props) {
    t1 = () => {
      if (props.onClick) {
        props.onClick();
      }
    };
    $[0] = props;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = props.logoSize?.height || (isMobile ? 36 : 40);
  const t3 = props.logoSize?.width || (isMobile ? 126 : 140);
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <chakra.span display="inline-flex"><StartupscomLogoSvg height={t2} width={t3} /></chakra.span>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t4) {
    t5 = <Link asChild={true}><NextLink href={t0} onClick={t1}>{t4}</NextLink></Link>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};